import * as React from 'react'

const PartiallyCloudyIcon = props => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8866 8.95774C12.8866 11.5955 10.7643 13.7338 8.14644 13.7338C5.52856 13.7338 3.40625 11.5955 3.40625 8.95774C3.40625 8.38244 3.50321 7.8397 3.68635 7.32953C4.34352 5.49507 6.08877 4.18164 8.14644 4.18164C8.81438 4.18164 9.43922 4.32275 10.0102 4.57241C11.7016 5.29968 12.8866 6.99303 12.8866 8.95774Z"
      fill="#FFC34A"
    />
    <path
      opacity="0.6"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.71743 7.58895C8.30805 7.54553 7.90945 7.45869 7.50007 7.4804C6.83213 7.51297 6.4012 7.86032 6.08878 8.43563C5.81945 8.93495 5.61476 9.53196 5.03301 9.74905C4.78523 9.84675 4.48358 9.81418 4.28966 9.6405C4.18193 9.54281 4.11729 9.4017 4.06343 9.27144C4.06343 9.26059 4.05265 9.26059 4.05265 9.24974C3.53554 7.99058 3.83719 6.52518 4.80677 5.56996C5.65785 4.72329 6.8429 4.19141 8.13568 4.19141C8.50197 4.19141 8.84671 4.23482 9.18068 4.31081C9.9348 4.48448 10.5273 5.0815 10.6458 5.85219C10.6458 5.88475 10.6566 5.91732 10.6566 5.94988C10.7967 7.10049 9.76243 7.6975 8.71743 7.58895Z"
      fill="#FFE332"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.63541 6.08008C5.55999 6.08008 5.48458 6.08008 5.40917 6.10179C5.02134 6.21034 4.69814 6.51427 4.56886 6.90504C4.49345 7.14385 4.50422 7.45864 4.7951 7.56718C4.84897 7.58889 4.9136 7.58889 4.96747 7.58889C5.19371 7.57804 5.36608 7.43693 5.53845 7.30667L6.09865 6.88333C6.17406 6.8182 6.2387 6.74222 6.2818 6.65538C6.36798 6.43829 6.24948 6.27546 6.08788 6.18863C5.99092 6.13435 5.87242 6.10179 5.76469 6.10179L5.63541 6.08008Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.77652 11.4437C5.7442 11.6283 5.75498 11.8237 5.84116 11.9973C6.29364 13.0285 7.9527 13.5604 8.73914 12.6378C9.07311 12.247 9.11621 11.6826 8.81456 11.2701C8.68528 11.0964 8.49136 10.977 8.29745 10.8793C7.66183 10.5862 6.59528 10.3257 6.04585 10.901C5.9058 11.053 5.80884 11.2484 5.77652 11.4437Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.89655 12.1271C6.85345 12.2465 6.875 12.3985 6.96118 12.507C7.04737 12.6156 7.18742 12.7024 7.32747 12.7458C7.46752 12.7892 7.63989 12.8001 7.76917 12.7133C7.99541 12.5287 7.92 12.1162 7.68299 11.986C7.5968 11.9426 7.49984 11.9209 7.41366 11.91C7.18742 11.8883 6.96119 11.8991 6.89655 12.1271Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.16809 8.95726C8.16809 8.96811 8.15732 8.97897 8.14655 8.97897C8.13577 8.97897 8.125 8.96811 8.125 8.95726C8.125 8.95726 8.125 8.95726 8.125 8.9464C8.125 8.93555 8.13577 8.93555 8.14655 8.93555H8.15732C8.16809 8.9464 8.16809 8.95726 8.16809 8.95726Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.14651 3.37742C7.86641 3.37742 7.6294 3.16032 7.59708 2.8781L7.41393 0.804834C7.39239 0.598593 7.56476 0.414062 7.76945 0.414062H8.5128C8.71749 0.414062 8.88986 0.598593 8.86831 0.804834L8.68517 2.8781C8.67439 3.16032 8.43738 3.37742 8.14651 3.37742Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.36288 6.15663C3.22283 6.40629 2.91041 6.50398 2.65185 6.38458L0.77732 5.51619C0.583403 5.42936 0.507991 5.19055 0.615723 5.00602L0.992784 4.35473C1.10052 4.1702 1.33753 4.11593 1.5099 4.23533L3.19051 5.42936C3.43829 5.59218 3.5137 5.90697 3.36288 6.15663Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.36288 11.7261C3.50293 11.9757 3.43829 12.2905 3.20128 12.4533L1.5099 13.6474C1.33753 13.7668 1.10052 13.7125 0.992784 13.528L0.615723 12.8767C0.507991 12.6921 0.583403 12.4533 0.77732 12.3665L2.65185 11.4873C2.92118 11.3787 3.22283 11.4764 3.36288 11.7261Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9306 6.15663C12.7906 5.90697 12.8552 5.59218 13.0922 5.42936L14.7836 4.23533C14.956 4.11593 15.193 4.1702 15.3007 4.35473L15.6778 5.00602C15.7855 5.19055 15.7101 5.4185 15.5162 5.51619L13.6524 6.39543C13.3831 6.50398 13.0815 6.40629 12.9306 6.15663Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.41032 4.19216C5.30259 4.25729 5.16253 4.22472 5.08712 4.11618L4.48382 3.1501C4.39764 3.00899 4.44073 2.82446 4.58078 2.74847C4.72083 2.66164 4.90398 2.71591 4.97939 2.86788L5.50728 3.87737C5.56114 3.98592 5.51805 4.12703 5.41032 4.19216Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.68446 8.97817C2.68446 9.10843 2.5875 9.21697 2.45822 9.21697L1.32704 9.26039C1.16544 9.27125 1.02539 9.14099 1.02539 8.97817C1.02539 8.81535 1.15467 8.68509 1.32704 8.69595L2.45822 8.73936C2.5875 8.75022 2.68446 8.85877 2.68446 8.97817Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8936 4.17059C10.7859 4.10546 10.7428 3.96435 10.7966 3.84494L11.3245 2.83545C11.3999 2.69434 11.5831 2.64006 11.7231 2.71605C11.8632 2.80289 11.9063 2.97656 11.8201 3.11767L11.2168 4.08375C11.1414 4.20315 11.0013 4.23572 10.8936 4.17059Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1287 14.4833C22.1395 14.8741 22.021 15.254 21.8055 15.5688C21.4823 16.0681 20.9221 16.4155 20.2434 16.4155H7.84347C7.10012 16.4155 6.42141 15.9813 6.13053 15.2974C6.0228 15.0478 5.95816 14.7656 5.92584 14.4833C5.9043 14.3097 5.9043 14.1251 5.9043 13.9514C5.96894 12.4969 6.89543 11.0424 8.29594 11.2378C8.29594 11.2378 8.29594 11.2378 8.30671 11.2378C8.28517 11.0315 8.29594 10.8253 8.31749 10.6299C8.65146 7.90533 12.8207 6.28797 14.6629 9.33817C14.8137 9.58783 14.943 9.8592 15.0615 10.1631C16.9252 8.36124 20.1464 10.2174 19.5431 12.6814C19.1337 14.3205 19.1337 14.3205 19.5431 12.6814C20.6312 12.5186 21.3638 12.8877 21.7732 13.4521C22.0102 13.7778 22.1179 14.136 22.1287 14.4833Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.7807 10.9118C14.7592 11.2374 14.673 11.6174 14.3713 11.7585C14.1128 11.8779 13.8111 11.7693 13.5741 11.6174C13.3371 11.4654 13.1217 11.2592 12.8523 11.1723C12.3137 11.0095 11.775 11.3677 11.3656 11.7476C10.9563 12.1275 10.5469 12.5834 9.99744 12.6594C9.50188 12.7354 8.99554 12.464 8.69389 12.0733C8.49997 11.8345 8.38147 11.5414 8.29528 11.2483C8.01518 8.1764 12.68 6.08142 14.6515 9.33786C14.77 9.84803 14.813 10.3799 14.7807 10.9118Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0097 13.1036C9.71883 13.3749 9.23403 13.2338 8.87852 13.4075C8.4045 13.6355 8.33986 14.2976 7.97357 14.6667C7.58574 15.0574 6.89626 15.0357 6.45456 14.7101H6.44378C6.04518 14.4061 5.88358 13.896 5.98054 13.4075C6.22832 12.1592 7.09017 11.0846 8.29677 11.2583C8.29677 11.2583 8.29677 11.2583 8.30754 11.2583C8.286 11.052 8.29677 10.8458 8.31832 10.6504C9.04012 10.7806 9.70805 11.2583 10.0312 11.9204C10.1174 12.1049 10.1821 12.3003 10.2036 12.5066C10.2144 12.7019 10.1713 12.9516 10.0097 13.1036Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2926 8.36143C12.2064 8.20946 12.0556 8.12263 11.8832 8.12263C11.463 8.11177 11.0429 8.15519 10.6766 8.36143C10.5689 8.42656 10.4503 8.5134 10.418 8.6328C10.3965 8.68708 10.3965 8.7522 10.3965 8.80648C10.3965 8.92588 10.4288 9.05614 10.515 9.15383C10.5904 9.24067 10.7197 9.28409 10.8274 9.27323C10.9351 9.26238 11.0536 9.21896 11.1506 9.15383C11.226 9.09956 11.2907 9.04528 11.3553 8.99101C11.4846 8.89332 11.6354 8.83904 11.797 8.80648C11.9263 8.78477 12.0556 8.77391 12.1633 8.70878C12.271 8.64366 12.3572 8.46998 12.2926 8.36143Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.89101 9.31641C9.81559 9.31641 9.74018 9.33812 9.68632 9.38154C9.56781 9.47923 9.48163 9.60949 9.41699 9.7506C9.38467 9.83744 9.36312 9.92427 9.3739 10.022C9.38467 10.1088 9.43853 10.2065 9.52472 10.2391C9.58936 10.2716 9.66477 10.2716 9.72941 10.2608C9.96642 10.2174 10.1711 10.0545 10.2465 9.82658C10.2788 9.73974 10.2896 9.64205 10.2681 9.54436C10.2357 9.4141 10.1172 9.32726 9.98797 9.32726L9.89101 9.31641Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.84279 11.7246C7.50883 11.7788 7.19641 11.9525 6.99172 12.2239C6.80857 12.4627 6.69007 12.7449 6.6362 13.038C6.62543 13.1248 6.62543 13.2334 6.69007 13.2877C6.73316 13.3202 6.78703 13.3311 6.84089 13.3311C6.92708 13.3419 7.01326 13.3419 7.09945 13.2985C7.22872 13.2334 7.28259 13.0923 7.32568 12.9512C7.43342 12.6798 7.60579 12.3976 7.87511 12.3107C7.89666 12.2999 7.90743 12.2999 7.92898 12.2999C8.02594 12.2782 8.11212 12.2022 8.15522 12.1153C8.26295 11.8874 8.03671 11.6812 7.84279 11.7246Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4715 10.3467C15.3961 10.4009 15.3315 10.4661 15.2884 10.5529C15.2453 10.6289 15.2345 10.7157 15.2668 10.7917C15.3315 10.9871 15.5577 10.9979 15.7193 10.9111C15.8486 10.846 15.9456 10.7266 16.0641 10.6397C16.2472 10.4986 16.4842 10.4118 16.7104 10.3575C16.7859 10.3358 16.8613 10.3141 16.9151 10.2707C16.969 10.2273 17.0121 10.1404 16.9798 10.0644C16.9475 9.98845 16.8505 9.96674 16.7751 9.95589C16.5165 9.92332 16.2472 9.96674 16.0102 10.0753L15.8917 10.1187C15.7409 10.173 15.6008 10.249 15.4715 10.3467Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.6935 13.4398C19.8766 13.4289 20.049 13.4289 20.2213 13.4398C20.523 13.4723 20.8354 13.5917 21.0293 13.8197C21.568 14.4493 21.1478 15.3936 20.426 15.6107C20.1244 15.7084 19.8012 15.7084 19.478 15.6867C19.0578 15.665 18.6269 15.6216 18.2714 15.3828C17.7974 15.068 17.6358 14.3407 18.0775 13.9174C18.2499 13.7546 18.4761 13.6677 18.7023 13.6026C19.0147 13.5375 19.3487 13.4615 19.6935 13.4398Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.377 14.4286C16.2154 14.5045 16.0646 14.624 15.9891 14.7325C15.9245 14.841 15.9353 14.9604 15.9784 15.069C16.0107 15.1558 16.043 15.2318 16.1077 15.2969C16.2908 15.4706 16.7217 15.4706 16.9264 15.3404C17.0988 15.2318 17.2388 14.9604 17.2065 14.7542C17.185 14.6131 17.0557 14.4611 16.9372 14.3851C16.7971 14.2875 16.5709 14.3309 16.377 14.4286Z"
      fill="#CBBEBB"
    />
  </svg>
)

export default PartiallyCloudyIcon
